const formatCSSProperty = (obj: object): string[] =>
  Object.entries(obj)
    .map(([key, value]) => value && `${[key]}_${value}`)
    .filter(Boolean);

export default formatCSSProperty;
